import React, { FC } from 'react';
import {
  Input,
  Box,
  Text,
  Center,
  Select,
  Container,
  Stack,
  Link,
  AbsoluteCenter,
  Alert,
  AlertIcon,
  Highlight
} from '@chakra-ui/react';

import { ComponentsWithLabel } from '../molecules/ComponentsWithLabel';
import { PageSendButton } from '../atom/button/PageSendButton';
import { DefaultLayout } from '../templates/DefaultLayout';
import { ButtonType, YoyakuSbtKbn } from '../types/teikihoan/commonDefinition';
import { ConfirmationCard } from '../molecules/ConfirmationCard';
import { ModalSpinner } from '../atom/spinner/ModalSpinner';
import { CommonDialog } from '../atom/dialog/CommonDialog';
import { AlertWithIcon } from '../atom/alert/AlertWithIcon';
import { useResevation } from '../hooks/useResevation';

export const InputResevationNo: FC = () => {
  const {
    yoyakuSbtList,
    yoyakuSearchInfo,
    customerInfo,
    errorMsg,
    getDataMsg,
    isLoading,
    digOpen,
    yoyakuIsToday,
    displayRirekiLink, // 2024.09 COMTEC kawaji ADD
    // actionApi, //2024.10 COMTEC kawaji ADD
    // rollbackApi, //2024.10 COMTEC kawaji ADD
    handlePrevClick,
    handleGetYoyakuInfo,
    handleYoyakuChange,
    handleCancelClick,
    onYoyakuCancel,
    handleSelectChange,
    handleInputChange,
    setDigOpen,
  } = useResevation();

  return (
    <>
      <DefaultLayout>
        <Container maxW="container.md">
          <CommonDialog
            // 2025.11 COMTEC kawaji MOD START
            // title="予約のキャンセル"
            title="予約キャンセルの確認"
            // 2025.11 COMTEC kawaji MOD END
            message={
              <>
                予約をキャンセルします。
                <br />
                よろしいですか？
              </>
            }
            buttonType={ButtonType.YesNo}
            isOpen={digOpen}
            onAccept={onYoyakuCancel}
            onClose={() => setDigOpen(false)}
          />

          {/* 2024.09 COMTEC kawaji MOD START */}
          {/* <form onSubmit={handleGetYoyakuInfo}> */}
          <form method="post" action={''} onSubmit={handleGetYoyakuInfo}>
            <input type="hidden" name="rollback" value={''} />
            {/* 2024.09 COMTEC kawaji MOD END */}
            <Box mt={10}>
              <Text mb={5}>
                ご予約いただいたサービス、受付番号を入力してください。
              </Text>
              <ComponentsWithLabel
                label="サービス"
                chkValue={yoyakuSearchInfo.yoyaku_sbt_cd !== ''}
              >
                <Select
                  placeholder="選択してください"
                  value={yoyakuSearchInfo.yoyaku_sbt_cd}
                  onChange={handleSelectChange}
                >
                  {yoyakuSbtList.map((gyomu) => (
                    <option key={gyomu.key} value={gyomu.key}>
                      {gyomu.name}
                    </option>
                  ))}
                </Select>
              </ComponentsWithLabel>
              <Box>
                <ComponentsWithLabel
                  label="受付番号"
                  chkValue={
                    yoyakuSearchInfo.uketsuke_no !== '' &&
                    yoyakuSearchInfo.uketsuke_no.length === 10
                  }
                >
                  <Input
                    // 2024.09 COMTEC kawaji MOD START
                    //type="tel"
                    type={
                      yoyakuSearchInfo.yoyaku_sbt_cd === YoyakuSbtKbn.event
                        ? 'text'
                        : 'tel'
                    }
                    // 2024.09 COMTEC kawaji MOD END
                    placeholder="0000000000"
                    maxLength={10}
                    value={yoyakuSearchInfo.uketsuke_no}
                    onChange={handleInputChange}
                  ></Input>
                  <Box ml={3}>
                    {yoyakuSearchInfo.yoyaku_sbt_cd ===
                      YoyakuSbtKbn.teikihoan ? (
                      <Box>10桁の数字を入力してください。</Box>
                    ) : (
                      <Box>10桁の英数字を入力してください。</Box>
                    )}
                  </Box>
                </ComponentsWithLabel>
              </Box>
              {errorMsg !== '' && (
                <AlertWithIcon status="error" mb={5} text={errorMsg} />
              )}
              <Stack
                direction={['column', 'row-reverse']}
                display={{ md: 'flex' }}
                width={{ base: '100%' }}
              >
                <PageSendButton
                  text="確認"
                  type="submit"
                  margin={1}
                ></PageSendButton>
                <PageSendButton
                  text="戻る"
                  type="button"
                  onClick={handlePrevClick}
                  margin={1}
                ></PageSendButton>
              </Stack>
              {/* </Box> */}
            </Box>
          </form>
          {getDataMsg !== '' && <AlertWithIcon mt={5} text={getDataMsg} />}
          {customerInfo !== null && (
            <Box mt={10}>
              <Text mb={5}>以下の内容でご予約を承っております。</Text>
              <ConfirmationCard
                cardTitle="受付内容"
                cardDetail={customerInfo}
              />
              {/* 2024.09 COMTEC kawaji MOD START */}
              {/* {yoyakuIsToday && (
                <AlertWithIcon
                  status="warning"
                  mt={5}
                  text="申し訳ございませんが、定期保安調査当日の予約変更の受付は電話のみとなります。お手数ですが、日本ガスカスタマーサポート（099-224-5232）までご連絡ください。"
                />
              )} */}
              {/* 2025.06 COMTEC kawaji MOD START */}
              {/* {yoyakuIsToday.isToday && (
                <AlertWithIcon
                  status="warning"
                  mt={5}
                  text={yoyakuIsToday.text}
                />
              )} */}
              {yoyakuIsToday.text !== '' && (
                <AlertWithIcon
                  status="warning"
                  mt={5}
                  text={yoyakuIsToday.text}
                />
              )}
              {/* 2025.06 COMTEC kawaji MOD END */}
              {/* 2024.09 COMTEC kawaji MOD END */}
              {/* 2026.01 COMTEC kawaji ADD START */}
              {(yoyakuSearchInfo.yoyaku_sbt_cd === YoyakuSbtKbn.kaisen || yoyakuSearchInfo.yoyaku_sbt_cd === YoyakuSbtKbn.heisen) && (
                <Alert status="info" mt={5} pl={4} pr={4}>
                  <Stack
                    direction={'column'}
                    width={'100%'}
                    textAlign={'left'}
                  >
                    <Stack direction={'row'} alignSelf={'left'}>
                      <AlertIcon />
                      <Text fontSize={'md'} as="b">予約内容の追加・削除について</Text>
                    </Stack>
                    <Text fontSize={'sm'} whiteSpace="pre-wrap">  [予約の確認・変更]からは、すでにご予約いただいている日程の変更や予約のキャンセルができます。<br />
                      <Highlight query={["追加・削除", "一度ご予約をキャンセル", "改めてお申込み"]} styles={{ color: 'red.500', fontWeight: 'bold' }}>
                        予約内容の追加・削除については、お手数ですが一度ご予約をキャンセルして、改めてお申込みください。
                      </Highlight>
                      <br />
                      ◆追加・削除の例<br />
                      【追加】ガスのみ予約しているが、電気も追加したい<br />
                      【削除】ガスと電気を予約しているが、どちらか一方をキャンセルしたい<br />
                      <br />
                      上記以外のお問い合わせは、お電話（099-250-5111）にてお願いいたします。</Text>
                  </Stack>
                </Alert>
              )}
              {/* 2026.01 COMTEC kawaji ADD END */}
              <Center>
                <Stack
                  direction={['column', 'row']}
                  mt={7}
                  display={{ md: 'flex' }}
                  width={{ base: '100%' }}
                >
                  <PageSendButton
                    text="予約を変更する"
                    type="button"
                    margin={1}
                    onClick={handleYoyakuChange}
                    //2025.10 COMTEC kawaji MOD START
                    // disabled={yoyakuIsToday.isToday} //2024.09 COMTEC kawaji MOD
                    disabled={yoyakuIsToday.noChangeDay}
                  //2025.10 COMTEC kawaji MOD END
                  ></PageSendButton>
                  <PageSendButton
                    text="予約をキャンセルする"
                    type="button"
                    margin={1}
                    onClick={handleCancelClick}
                    disabled={yoyakuIsToday.isToday} //2024.09 COMTEC kawaji MOD
                  ></PageSendButton>
                </Stack>
              </Center>
            </Box>
          )}
          {/* 2024.09 COMTEC kawaji ADD START */}
          {yoyakuSearchInfo.yoyaku_sbt_cd === YoyakuSbtKbn.event &&
            displayRirekiLink.isDisplay ? (
            <Box position={'relative'}>
              <AbsoluteCenter mt={7}>
                <Link width={'100%'} href={displayRirekiLink.link}>
                  暮らしサービス履歴へ
                </Link>
              </AbsoluteCenter>
            </Box>
          ) : (
            <></>
          )}
          {/* 2024.09 COMTEC kawaji ADD END */}

          <ModalSpinner isOpen={isLoading} />
        </Container>
      </DefaultLayout>
    </>
  );
};
